/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

/* global _ */
import OkC from "shared/util/OkcApi";

const WebUtil = {};

function __guard__(value, transform) {
	return (typeof value !== "undefined" && value !== null) ? transform(value) : undefined;
}

const _fetchMatchesExpress = () => {
	return OkC.get("/quickmatch", {
		api: 1,
	});
};

WebUtil.loadData = () => {
	return OkC.get("/locals/reflux");
};

WebUtil.fetchMatches = () => {
	return OkC.post("/locals/web", {
		data: {
			okc_api: 1,
			react: 1,
		},
	});
};

WebUtil.vote = ({ like, queue, userid, keys, flavor, user }) => {
	const params = {
		okc_api: 1,
		react: 1,
		target_userid: userid,
		keys,
		flavor,
		exclude: userid,
		vote_type: "personality",
		user_data: user.user_data,
		text_queue: queue.reduce((uids, user) => {
			if (user.userid === userid) { return uids; }

			if (uids) {
				return `${uids},${user.userid}`;
			} else {
				return `${user.userid}`;
			}
		}, ""),
	};

	if (like) {
		params.score = 4;
	} else {
		params.score = 0;
		params.cant_tell = 1;
	}

	return OkC.post("/locals/web", {
		data: params,
	})
		.then((res) => {
			if (res && res.error) {
				throw new Error(res);
			}

			return res;
		});
};

WebUtil.undo = ({ userid }) => {
	return OkC.post(`/profile/${userid}/unlike`, {
		api: 1,
	});
};

WebUtil.selectFlavor = ({ flavor }) => {
	return new Promise(((resolve, reject) => {
		return OkC.legacy("/quickmatch", {
			data: {
				okc_api: 1,
				react: 1,
				flavor,
			},

			success(response, status, jhxr) {
				if (
					((response != null ? response.error : undefined) != null) ||
					!__guard__(response != null ? response.matches : undefined, (x) => x.length)
				) {
					return reject(response, jhxr);
				} else {
					return resolve(response, status, jhxr);
				}
			},

			error(jhxr) {
				let response = jhxr != null ? jhxr.responseJSON : undefined;

				if (!response) {
					response = {
						error: {
							message: "No error response",
							type: "DefaultError",
						},
					};
				}

				// don't call back if the user aborted
				if (!(jhxr != null ? jhxr.statusText : undefined) || (jhxr.statusText !== "abort")) {
					return reject(response, jhxr);
				}
			},
		});
	}));
};

WebUtil.showFlavorLikes = ({ flavor }) => {
	return OkC.get("/flavors/likes", {
		api: 1,
		data: {
			flavorid: flavor,
			fields: [
				"userinfo",
				"thumbs",
				"percentages",
				"online",
			].join(","),
		},
	});
};

WebUtil.resetFlavors = () => {
	return new Promise(((resolve, reject) => {
		return OkC.delete("/flavors/dailies", {
			api: 1,

			success() {
				return OkC.get("/flavors/dailies", {
					api: 1,

					success(response, status, jhxr) {
						return resolve(response, status, jhxr);
					},

					error() {
						return reject();
					},
				});
			},

			error() {
				return reject();
			},
		});
	}));
};

WebUtil.mark = (experiments) => {
	return OkC.post("/experiments/mark", {
		api: 1,
		data: {
			experiments,
		},
	});
};

WebUtil.incrementLikesCapModalViewCount = () => {
	return OkC.post("/rate_card/view", {
		version: 1,
		data: {
			promo_id: "alist.likescappaywall",
		},
	});
};

export default WebUtil;



// WEBPACK FOOTER //
// ./src/reflux/quickmatch/util/WebUtil.js